
import React, {FC, useState} from 'react';
import {CloseButton} from 'react-bootstrap';
import {Location} from 'components/TimePicker/types';
import {LocationCard, Modal} from 'pages/booking/components/LocationCard';
import {Configs} from 'pages/booking/components/useLocation/types';

import * as styles from './styles.module.scss';

type DetailsProps = {
	location: Location
	onClose: () => void
}

type UserDetailsProps = {
	config: Configs
	onClose: () => void
}

const Details: FC<DetailsProps> = ({location, onClose}) => {
	const [mref, setModal] = useState<React.ReactNode>();
	const onExpand = () => {
		const onHide = () => setModal(null);
		setModal(() => (
			<Modal onHide={onHide}>
				<LocationCard
					location={location}
					modal={{onHide}}
				/>
			</Modal>
		));
	};

	const {details} = location;
	return (
		<div className={styles.content}>
			<div className={styles.header}>
				<span className={styles.title}>
					{details.name}
				</span>
				<CloseButton onClick={onClose} />
			</div>
			<span className={styles.address}>
				{details.address.addr1}<br />
				{details.address.addr2}
			</span>
			<span className={styles.link} onClick={onExpand}>
				Show all time slots
			</span>
			{mref}
		</div>
	);
};

const UserDetails: FC<UserDetailsProps> = ({config, onClose}) => {
	const [mref,] = useState<React.ReactNode>();
	return (
		<div className={styles.content}>
			<div className={styles.header}>
				<span className={styles.title}>
					Your Location
				</span>
				<CloseButton onClick={onClose} />
			</div>
			<span className={styles.address}>
				{config.label}
			</span>
			{mref}
		</div>
	);
};

export default Details;
export {UserDetails};
